import { useEffect, useMemo, useState } from "react"
import {
	Box, BoxProps, Alert, List
} from "@mui/material"

import { ErrorInfo } from "components/controls/errorInfo"
import { Loading } from "components/controls/loading"

import { MrpProjectResult, useListMrpLog, useListMrpProject } from "interface/carenet/mrp"
import { SearchDetailResult } from "interface/search"

import { SourceProject } from "../../../types"
import { MrpProjectRecord } from "./mrpProjectRecord"
import { safeParseDate } from "shared/util"

type MrpProjectListProps = {
	search: SearchDetailResult
	searchWord: string
	exclusiveList: SourceProject[]
	onAddProject: (project: SourceProject) => void
} & BoxProps
export const MrpProjectList = ({
	search,
	searchWord,
	exclusiveList,
	onAddProject,
	...others
}: MrpProjectListProps) => {
	const [selected, setSelected] = useState<MrpProjectResult | null>(null)

	const projectListState = useListMrpProject(true, search.searchId)
	const projectList = useMemo(
		() => {
			const projectList = projectListState.data?.list.filter(
				p => {
					if (searchWord !== "") {
						if (
							(!p.projectName || !p.projectName.toLowerCase().includes(searchWord.toLowerCase())) &&
							(!p.productName || !p.productName.toLowerCase().includes(searchWord.toLowerCase()))
						) return false
					}
					return !exclusiveList.some(e => e.projectId === p.projectId)
				}
			) ?? []
			return projectList
		},
		[projectListState.data, exclusiveList, searchWord]
	)
	const logListState = useListMrpLog(selected?.projectId)
	useEffect(
		() => {
			if (!selected || !logListState.data) return
			if (logListState.data.list.length > 0) {
				onAddProject({
					source: 'mrp',
					projectId: selected.projectId,
					projectName: selected.projectName ?? '',
					productName: selected.productName ?? null,
					projectDate: safeParseDate(selected.startDate) ?? null,
					logList: logListState.data.list
				})
			}
			setSelected(null)
		},
		[logListState.data, onAddProject, selected, setSelected]
	)
	if (projectListState.loading) return <Loading/>
	if (projectListState.error) return <ErrorInfo error={projectListState.error}/>
	if (!projectListState.data) return <></>
	return (
		<Box {...others}>
			{logListState.loading && <Loading/>}
			<ErrorInfo error={projectListState.error}/>
			{projectList.length === 0 ? (
				<Box padding={1}>
					<Alert severity="info">対象が見つかりません.</Alert>
				</Box>
			) : (
				<List disablePadding>
					{projectList.map(project => (
						<MrpProjectRecord
							key={`mrp-project-${project.projectId}`}
							project={project}
							onOpenProject={setSelected}
						/>
					))}
				</List>
			)}
		</Box>
	)
}
